import React, { Fragment, useState, useEffect } from 'react';

export default () => {
  const [hover3, updateHover3] = useState(false);
  useEffect(() => {
    document.title = '陕西奕诚生物科技有限公司 - 首页';
  });
  return (
    <Fragment>
      <div className="show-case">
        <div className="slogan">
          <div className="title">
          </div>
        </div>
        <div className="features">
          <div className="foreword">
            <span>我们专注且执着于这些事情...</span>
          </div>
          <div className="feature feature1">
            <i></i>
            <span className="title">药用植物粗加工及推广种植</span>
          </div>
          <div className="feature feature2">
            <i></i>
            <span className="title">经济作物加工</span>
          </div>
          <div className="feature feature3" onMouseEnter={() => updateHover3(true)} onMouseLeave={() => updateHover3(false)}>
            <i></i>
            <span className="title">珍稀植物生物提取</span>
            <span></span>
            {hover3 ? <span className="explanation">通过分析实验，从植物种子中提取高经济价值物质</span> : null}
          </div>
        </div>
      </div>
      <div className="index-background">
      </div>
      <div className="achievements">
        <div className="foreword row">
          <span>我们拥有这样的优势和成就</span>
        </div>
        <div className="content row">
          <div className="achievement incubating">
            <div className="icon icon-index-incubating"></div>
            <span className="title">科技孵化</span>
            <span className="desc">多项提取与培养专利技术</span>
          </div>
          <div className="achievement scale">
            <div className="icon icon-index-scale"></div>
            <span className="title">公司规模</span>
            <span className="desc">超大型生产加工厂房与</span>
            <span className="desc">研发中心</span>
          </div>
          <div className="achievement cultivation">
            <div className="icon icon-index-cultivation"></div>
            <span className="title">培育基地</span>
            <span className="desc">实现有机化全产业链</span>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
